import Faye from 'faye'
import { eventChannel } from 'redux-saga'
import { bindAll, isUndefined, isObject } from 'lodash-es'

const TIMEOUT = 120

class RealtimeClient {
  constructor() {
    bindAll(this, 'connect', 'subscribe', 'subscribeThroughSagaChannel')

    this.subscriptions = {}
    this.sagaEventChannels = {}
  }

  connect(realtimeURL, authInfo, useFakeServer) {
    this.useFakeServer = useFakeServer

    if (!this.client) {
      if (this.useFakeServer) {
        this.client = new Faye.Client('http://localhost:8000/faye', {
          timeout: TIMEOUT,
        })
      } else {
        this.client = new Faye.Client(realtimeURL, { timeout: TIMEOUT })
        this.client.disable('websocket')

        if (!isUndefined(authInfo)) {
          this.client.setHeader('Authorization', authInfo)
        }
      }
    }

    return this
  }

  subscribe(channelName, callback) {
    const channel = this.useFakeServer ? '/channel' : channelName

    return this.client.subscribe(channel, (data) => {
      if (isObject(data)) {
        callback(data)
      } else {
        callback(JSON.parse(data))
      }
    })
  }

  subscribeThroughSagaChannel(channelName) {
    if (this.sagaEventChannels[channelName]) {
      return this.sagaEventChannels[channelName]
    }

    this.sagaEventChannels[channelName] = eventChannel((emitter) => {
      this.subscriptions[channelName] = this.subscribe(channelName, (data) => {
        emitter(data)
      })

      return this.cancelSubscription.bind(this, channelName)
    })

    return this.sagaEventChannels[channelName]
  }

  cancelSubscription(channelName) {
    if (this.subscriptions[channelName]) {
      this.subscriptions[channelName].cancel()
      delete this.subscriptions[channelName]
    }

    if (this.sagaEventChannels[channelName]) {
      delete this.sagaEventChannels[channelName]
    }
  }
}

export default RealtimeClient
